import { SET_TIME_FORMAT } from 'containers/mainPanel/timeFormats/constants'

export const setTimeFormat = (timeFormat) => ({
  type: SET_TIME_FORMAT,
  timeFormat,
})
